import { render, staticRenderFns } from "./ImageScanUpload.vue?vue&type=template&id=14d2bb85&scoped=true&"
import script from "./ImageScanUpload.vue?vue&type=script&lang=js&"
export * from "./ImageScanUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d2bb85",
  null
  
)

export default component.exports